module.exports = __webpack_public_path__ + "static/fonts/roboto-v20-latin-300-806854d4422d0bd79e0f8c87c329a568.ttf";